import React, { useEffect, useState, useRef } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores/Store';
import './style.scss';
import { TextInput, OutlinedButton } from '../../../components';
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleLogo.svg`;
const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;
const DeleteIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/DeleteIcon.svg`;
const EditIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/EditIcon.svg`;
var mobile = require('is-mobile');

const Profile = observer(() => {
    const store = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [IsEditDetails, setIsEditDetails] = useState(false);
    const [IsEditPassword, setIsEditPassword] = useState(false);
    const [FullName, setFullName] = useState('');
    const [User, setUser] = useState({});
    const [Password, setPassword] = useState('');
    const [ConfirmPassword, setConfirmPassword] = useState('')
    const EmailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    useEffect(() => {
        getUser();
    }, []);
    const getUser = () => {
        setUser({ ...store.user });
        const fullName = `${store.user.firstName} ${store.user.lastName}`;
        setFullName(fullName);
        forceUpdate();
    };
    const handleEditPassword = () => {
        setIsEditDetails(true);
        setIsEditPassword(true);
        forceUpdate();
    };
    const handleEditPasswordClose = () => {
        setIsEditDetails(false);
        setIsEditPassword(false);
        forceUpdate();
    };
    const handleUserInfoChange = (e) => {
        let user = User;
        if (e.currentTarget.id === 'FullName') {
            let fullName = e.target.value;
            user.firstName = fullName.split(' ')[0];
            user.lastName = fullName.split(' ')[1];
            setFullName(fullName);
        }
        if (e.currentTarget.id === 'Email') {
            user.email = e.target.value;
        }
        if (e.currentTarget.id === 'Phone') {
            user.phone = e.target.value;
        }
        setUser(user);
        forceUpdate();
    };
    const handleUpdateUserClicked = async () => {
        let user = User;
        let userEmail = store.user.email;
        let regexPass = EmailRegex.test(user.email);
        store.setLoading(true);
        if (!regexPass) {
            alert('Invalid email address.');
            store.setLoading(false);
            return;
        } else {
            let updateUser = await store.updateUserByEmail(user, userEmail)
            if (updateUser !== 'error') {
                store.user = updateUser
                setUser(updateUser);
                setIsEditDetails(false);
                setIsEditPassword(false);
            }
            store.setLoading(false);
        }

    };
    const handlePasswordChange = async (e) => {
        let user = User;
        if (e.currentTarget.id === 'Password') {
            setPassword(e.target.value)
        }
        if (e.currentTarget.id === 'ConfirmPassword') {
            setConfirmPassword(e.target.value);
        }
        setUser(user);
        forceUpdate();
    };
    const handleUpdatePasswordClicked = async () => {
        store.setLoading(true);
        try {
            let regexPass = validatePassword(Password);
            if (regexPass === '' || undefined) {
                alert('Passwords do not match')
                store.setLoading(false);
                return;
            }

            if (regexPass !== ConfirmPassword) {
                alert('Passwords do not match')
                store.setLoading(false);
                return;
            }
            let updatePassword = await store.updatePassword(store.user.email, regexPass);
            if (!updatePassword || updatePassword === 'error') {
                alert('Error updating passowrd');
                store.setLoading(false);
                return;
            }
            alert('Password updated successfully.');
            setIsEditDetails(false);
            setIsEditPassword(false);
            store.setLoading(false);
            forceUpdate();
        } catch (error) {
            console.log(error)
            alert('An error occurred while updating the password. Please try again later.')
            store.setLoading(false);
            return
        }
        // let user = { ...User };
        // let regexPass = validatePassword(user.password);

        // setError(true);
        // let updatePassword = await store.updatePassword(store.user.email, passw)
    };
    function validatePassword(password) {
        if (!password) {
            alert('Password is required.')
            return '';
        };
        if (!/(?=.*[a-z])/.test(password)) {
            alert('Password must contain at least one lowercase letter.')
            return '';
        };
        if (!/(?=.*[A-Z])/.test(password)) {
            alert('Password must contain at least one uppercase letter.')
            return '';
        };
        if (!/(?=.*[0-9])/.test(password)) {
            alert('Password must contain at least one digit.')
            return '';
        };
        if (!/(?=.*[!@#\$%\^&\*])/.test(password)) {
            alert('Password must contain at least one special character (!@#$%^&*).')
            return;
        };
        if (!/(?=.{8,})/.test(password)) {
            alert('Password must be at least 8 characters long.')
            return '';
        };
        return password;
    };
    const fileInputRef = useRef(null);
    const handleAddDevice = async () => {
        store.setLoading(true);
        try {
            let addWebauthn = await store.addWebauthn();
            store.setLoading(false);
        } catch (e) {
            console.log(e);
            alert('Failed to add device. Please try again.');
            store.setLoading(false);
        }

    };
    const handleDeleteBiomet = async (e) => {
        store.setLoading(true);
        let userEmail = store.user.email;
        try {
            let user = User;
            let auths = user.Authenticators;
            if (e >= 0 && e < auths.length) {
                auths.splice(e, 1);
            }
            let updateUser = await store.updateUserByEmail(user, userEmail);
            if (!updateUser) {
                alert('');
                store.setLoading(false);
                return
            };
            store.setLoading(false);
            forceUpdate();
        } catch (error) {
            console.log(error);
            store.setLoading(false);
            return
        }
    };
    if (mobile()) {
        return (
            <div>
            </div>
        );
    } else {
        return (
            <div className='user-profile-Container'>
                <div className='profile-top-section'>
                    <p>Profile</p>
                    <img src={Credipple} alt='' />
                </div>
                <div className='profile-body'>
                    <div className='user-details'>
                        <div className='details-header'>
                            <p>Details</p>
                        </div>
                        <div className="user-profile" style={{ backgroundColor: '#eaeaea' }}>
                            <img style={{ width: '100%', height: '100%' }} src={UserIcon} alt=''/>
                        </div>
                        <input type="file" ref={fileInputRef} style={{ display: 'none' }} accept="image/*" />
                        {(IsEditDetails) ?
                            <div className='update-user-Details'>
                                <TextInput className='userDetails-inputs' label='Name & Surname' value={FullName} id='FullName' onChange={handleUserInfoChange} />
                                <TextInput className='userDetails-inputs' label='Email' value={User.email} id='Email' onChange={handleUserInfoChange} />
                                <TextInput className='userDetails-inputs' label='Contact Number' value={User.phone} id='Phone' onChange={handleUserInfoChange} />
                                <OutlinedButton className='btn-Cancel' onClick={handleEditPasswordClose}>Cancel</OutlinedButton>
                                <OutlinedButton className='btn-Save' onClick={handleUpdateUserClicked}>Save</OutlinedButton>
                            </div> :
                            <div className='user-detail-container' >
                                <p className='placeHolder'>Name & Surname</p>
                                <p className='value'>{User.firstName || ''} {User.lastName || ''}</p>
                                <p className='placeHolder'>Email</p>
                                <p className='value'>{User.email || ''}</p>
                                <p className='placeHolder'>Contact Number</p>
                                <p className='value'>{User.phone || ''}</p>
                            </div>}
                    </div>
                    <div className='user-password'>
                        {(IsEditPassword) ?
                            <div className='updatepassword-sect'>
                                <div className='updateSecurity-header'>
                                    <p className='title'>Security</p>
                                </div>
                                <div className='passwordFields-section'>
                                    <TextInput className='text-input' label='New Password' type='password' id='Password' onChange={handlePasswordChange} />
                                    <TextInput className='text-input' label='Confirm Password' type='password' id='ConfirmPassword' onChange={handlePasswordChange} />
                                </div>
                                <div className='security-action-Container'>
                                    <OutlinedButton className='btn-Cancel' onClick={handleEditPasswordClose}>Cancel</OutlinedButton>
                                    <OutlinedButton className='btn-Save' onClick={handleUpdatePasswordClicked}>Save</OutlinedButton>
                                </div>
                            </div> :
                            <div className='security-Password'>
                                <div className='security-header'>
                                    <p className='title'>Security</p>
                                    <img style={{ cursor: 'pointer' }} onClick={handleEditPassword} src={EditIcon} alt='' />
                                </div>
                                <div className='security-body'>
                                    <p className='placeHolder' style={{ margin: ' 0 0 1% 0 ' }}>Password</p>
                                    <p className='value' style={{ margin: '0px', color: '#AFAFAF' }}>**********</p>
                                    {/* <TextInput className='passwordField' label='Password' type='password' /> */}
                                </div>
                            </div>}
                        <div className='user-device-biometrics'>
                            <div className='AddDevice-biometrics'>
                                <p>Device Biometrics</p>
                                <div style={{ cursor: 'pointer' }}>
                                    <img src={AddIcon} alt='' onClick={handleAddDevice} />
                                    <p onClick={handleAddDevice}>Add</p>
                                </div>
                            </div>
                            <div className='avail-device-biometrics'>
                                <div className='label-section'>
                                    <p style={{ width: '45%' }}>Device Key</p>
                                    {/* <p style={{ width: '50%' }}>Date Added</p> */}
                                </div>
                                <div className='Devices-container'>
                                    {User.Authenticators && User.Authenticators.length > 0 ? (
                                        User.Authenticators.map((item, index) => {
                                            let key = item.authrInfo.publicKey;
                                            let displayKey = `${key.slice(0, 12)}...`;
                                            return (
                                                <div className='device-section' key={index}>
                                                    <p style={{ width: '95%' }}>{displayKey || ''}</p>
                                                    <img style={{ cursor: 'pointer' }} src={DeleteIcon} alt='Delete Icon' onClick={() => handleDeleteBiomet(index)} />
                                                </div>
                                            )
                                        })
                                    ) : (
                                        <div className='device-section'>
                                            <p style={{ width: '95%' }}>No Authenticators</p>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
})

export default Profile;